import { FC, PropsWithChildren, ReactElement } from 'react'

import { Box, Button, Collapsible, Flex, HStack, Icon, Spinner } from '@chakra-ui/react'
import { BigChevronRightIcon as ChevronRightIcon } from '@editor/assets/icons'

const CollapsePanel: FC<
  PropsWithChildren & {
    title: string
    isCollapsed?: boolean
    isLoading?: boolean
    onChange?: (open: boolean) => void
    preCollapse?: ReactElement
    headerRight?: ReactElement
  }
> = ({ children, title, preCollapse, headerRight, isCollapsed, isLoading, onChange }) => (
  <Collapsible.Root open={!isCollapsed} onOpenChange={(e) => onChange?.(!e.open)} w="100%">
    <Flex
      w="100%"
      maxH="100%"
      flex={1}
      flexDirection="column"
      className={!isCollapsed ? 'opened' : 'collapsed'}
      overflowX="hidden"
      overflowY="auto"
    >
      <Collapsible.Trigger asChild>
        <Button
          w="100%"
          variant="layer"
          paddingInlineStart={0}
          className="panel-header"
          position="sticky"
          top={0}
          left={0}
          zIndex={11}
        >
          <HStack flex={1}>
            <Box flex={1} textAlign="left" pl={2}>
              {title}
              {headerRight}
            </Box>
            {isLoading && <Spinner size="sm" />}
          </HStack>
          <Icon as={ChevronRightIcon} boxSize={4} />
        </Button>
      </Collapsible.Trigger>
      <Flex position="relative" flex={1} flexDirection="column">
        {preCollapse}
        <Collapsible.Content data-testid="panel-contents" style={{ flex: 1 }}>
          {children}
        </Collapsible.Content>
      </Flex>
    </Flex>
  </Collapsible.Root>
)

export default CollapsePanel
